

import { useState } from 'react';

import { visuallyHidden } from '@mui/utils';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import { Box, TableSortLabel } from '@mui/material';

import { Button, Menu, MenuHandler, MenuItem, MenuList, Spinner, Tooltip, Typography } from '@material-tailwind/react';

import DownloadIcon from '../../images/icons/DownloadIcon';

import { useTranslation } from 'react-i18next';

import { isIterableArray, numWord, toFormatPrice, toStringPrice, } from '../../utils/utils';
import { OrderType } from '../tableHelpers/tableConfig';
import axios from 'axios';
import { baseApi } from '../../ConfigApi';
import TableToolbar from '../tableHelpers/TableToolbar';
import SelectIcon from '../../images/icons/SelectIcon';
import fileDownload from 'js-file-download';
import { ActRowType, ActsHeadCell } from './ActsPage.types';
import FileIcon from '../../images/icons/FileIcon';
import DownloadBtn from '../tableHelpers/buttons/DownloadBtn';
import { errorToast } from '../../components/toasts/toasts';
import TableEmptyRows from '../tableHelpers/TableEmptyRows';
import ActsCards from './mobile/ActsCards';
import MoreDotsIcon from '../../images/icons/MoreDotsIcon';
import ModalViewPdf from './ModalViewPdf';
import ExcelIcon from '../../images/icons/ExcelIcon';
import { useParams } from 'react-router-dom';
import EyeIcon from '../../images/icons/EyeIcon';
import { hasRoleAccess, RolesType } from '../../utils/roles';

type PropsType = {
    without_facsimile: any,
    roles: RolesType | undefined
    isLoadingTable: boolean,
    rows: ActRowType[],
    visibleRows: ActRowType[],
    orderBy: keyof ActRowType,
    order: OrderType,
    service_id: any,
    handleRequestSort: any,
}
const ActTableDumb = (props: PropsType): JSX.Element => {

    const { t } = useTranslation()
    const {
        without_facsimile,
        roles,
        isLoadingTable,
        rows,
        visibleRows,
        orderBy,
        order,
        service_id,
        handleRequestSort
    } = props

    const { param_contract_id } = useParams()
    // ______SERVICE COLORS

    const textSearchService = service_id === 1 ? 'bg-orange-100' : service_id === 2 ? 'bg-blue-100' : 'bg-gray-200'
    const hoverRowService = service_id === 1 ? 'hover:!bg-orange-50' : service_id === 2 ? 'hover:!bg-blue-100' : 'hover:!bg-gray-200'
    const sortIconService = service_id === 1 ? 'svg-sort-orange' : service_id === 2 ? 'svg-sort-blue' : ''

    // array selected id's
    const [selected, setSelected] = useState<number[]>([]);


    // ______MODAL VIEW PDF
    const [formForViewPdf, setFormForViewPdf] = useState<any>(null);
    const [open, setOpen] = useState(false);
    const handleOpen = (row: ActRowType, isWithoutFacsimile?: boolean) => {
        // const formSend = {
        //     number: row.number,
        //     balance_id: row.balance_id,
        //     invoice_type: row.invoice_type,
        //     version: row.version,
        //     contract_id: param_contract_id,
        //     filename: row.filename
        // }
        setFormForViewPdf({
            ...row, ...(isWithoutFacsimile && { without_facsimile: true })
        })
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false)
        setFormForViewPdf(null)
    };


    // ______CHECKBOXS

    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    const handleClickSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = rows.map((item: any) => item.id);
            setSelected(newSelected)
        }
        else setSelected([])
    };

    const handleClickCheckbox = (event: React.MouseEvent<unknown>, id: number) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected)
    };
    // _____


    function TableHeadComponent() {
        const createSortHandler = (property: keyof ActRowType) => (event: React.MouseEvent<unknown>) => {
            handleRequestSort(event, property);
        };
        return (
            <TableHead className='table-head-border border-none font-sans'>
                <TableRow>
                    <TableCell className='font-sans' padding="checkbox" sx={{ paddingBottom: '0', border: 'none' }} >
                        <Checkbox
                            disableRipple={true}
                            className={`svg-checkbox-dark hover:bg-white`}
                            indeterminate={selected.length > 0 && selected.length < rows.length}
                            checked={rows.length > 0 && selected.length === rows.length}
                            onChange={handleClickSelectAll}
                        />
                    </TableCell>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={'normal'}
                            sx={{ paddingBottom: '0px !important', paddingTop: '0px !important', border: 'none' }}
                            className={`!font-sans ${headCell.className}`}
                        >
                            {
                                headCell.sorting ?
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : 'asc'}
                                        onClick={createSortHandler(headCell.id)}
                                        className={`${sortIconService} text-base !text-gray text-nowrap`}
                                    >
                                        {t(headCell.label)}
                                        {orderBy === headCell.id ? (
                                            <Box component="span" sx={visuallyHidden} >
                                                <>
                                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                </>
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                    :
                                    <span className='text-base font-normal !text-gray-600 whitespace-nowrap'>
                                        {t(headCell.label)}
                                    </span>
                            }
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }
    function TableRowsRender({ cells, row }: { cells: ActsHeadCell[], row: ActRowType }) {
        return (
            <>
                {
                    cells.map((cell, index) => {
                        const key = cell.dataIndex
                        return (
                            <TableCell
                                key={cell.dataIndex}
                                align={cell.align}
                                sx={{
                                    border: 'none', lineHeight: '120%',
                                    borderTopRightRadius: index === cells.length - 1 ? 16 : 0,
                                    borderBottomRightRadius: index === cells.length - 1 ? 16 : 0
                                }}
                                padding={'normal'}
                                className='!font-sans !text-gray-700 !text-[16px]'
                            >
                                {
                                    cell.render ?
                                        cell.render(row[key], row)
                                        :
                                        row[key]
                                }
                            </TableCell>
                        )
                    })
                }
            </>
        )
    }

    const headCellsData: ActsHeadCell[] = [
        {
            dataIndex: 'period', // какое поле в таблице
            id: 'period_sorter', // какое поле в сортировке
            align: 'left',
            sorting: true,
            label: 'acts_page.period',
            className: 'min-w-[80px]',
            render: (item: any, record?: any) => (
                <span className='text-gray-700'>
                    {/* {isSubst(item)} */}
                    {item}
                </span>
            )
        },
        {
            dataIndex: 'number',
            id: 'number',
            sorting: true,
            align: 'left',
            label: 'acts_page.number',
            className: 'min-w-[120px]',
            render: (item: any, record?: any) => (
                <span className='text-gray-700'>
                    {/* {isSubst(item)} */}
                    {item}
                </span>
            )
        },
        {
            hidden: service_id === 2,
            dataIndex: 'act_type_table',
            id: 'act_type',
            sorting: true,
            align: 'left',
            label: 'acts_page.act_type',
            className: 'min-w-[170px]',
            render: (item: any, record: any) => (
                <div className={`text-gray-700`}>
                    {item}
                </div>
            )
        },
        {
            dataIndex: 'balance_id_table',
            id: 'balance_id',
            sorting: true,
            align: 'left',
            label: `acts_page.balance_id`,
            className: 'min-w-[170px]',
            render: (item: any, record: any) => (
                <div className={`text-gray-700`}>
                    {item}
                </div>
            )
        },
        {
            dataIndex: 'count',
            id: 'count',
            sorting: true,
            align: 'left',
            label: `acts_page.count_service_${service_id}`,
            className: 'min-w-[150px]',
            render: (item: any, record: any) => (
                <div className={`text-gray-700`}>
                    {item ? toFormatPrice(item, 3) : ' - '}
                </div>
            )
        },
        {
            dataIndex: 'price',
            id: 'price',
            sorting: true,
            align: 'left',
            label: `acts_page.price_service_${service_id}`,
            className: 'min-w-[150px]',
            render: (item: any, record: any) => (
                <div className={`text-gray-700`}>
                    {toFormatPrice(item)}
                </div>
            )
        },
        {
            dataIndex: 'amount_with_nds',
            id: 'amount_with_nds',
            sorting: true,
            align: 'left',
            label: `acts_page.amount_with_nds`,
            className: 'min-w-[150px]',
            render: (item: any, record: any) => (
                <span className={`text-[16px] font-bold text-gray-700`}>
                    {toFormatPrice(item)}
                </span>
            )
        },
        // {
        //     dataIndex: 'amount_for_payment',
        //     id: 'amount_for_payment',
        //     sorting: true,
        //     align: 'left',
        //     label: `acts_page.amount_for_payment`,
        //     className: 'min-w-[150px]',
        //     render: (item: any, record: any) => (
        //         <span className={`text-[16px] font-bold text-gray-700`}>
        //             {toFormatPrice(item)}
        //         </span>
        //     )
        // },
        {
            dataIndex: 'id',
            id: 'id',
            align: 'left',
            label: ` `,
            className: 'w-[164px]',
            render: (item: any, record: any) => (
                <div className={`text-gray-600`}>
                    <div className='flex items-center gap-[4px]'>


                        {
                            hasRoleAccess('acts.download', roles) &&
                            <Tooltip content={t('invoices_page.view_file')} placement='top'>
                                {
                                    without_facsimile ?
                                        <Menu placement="bottom-end">
                                            <MenuHandler>
                                                <Button
                                                    color="white"
                                                    size={'sm'}
                                                    className={`w-[40px] h-[40px] flex gap-[12px] items-center justify-center`}
                                                >
                                                    <EyeIcon />
                                                </Button>
                                            </MenuHandler>
                                            <MenuList >
                                                <MenuItem
                                                    onClick={(event: any) => {
                                                        event.stopPropagation()
                                                        handleOpen(record)
                                                    }}
                                                    className={`flex items-center gap-[6px] py-[10px] px-[16px] text-gray-700`}
                                                >
                                                    {t('invoices_page.view_file')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={(event: any) => {
                                                        event.stopPropagation()
                                                        handleOpen(record, true)
                                                    }}
                                                    className={`flex items-center gap-[6px] py-[10px] px-[16px] text-gray-700`}
                                                >
                                                    {t('invoices_page.view_file')} {t('without_facsimile')}
                                                </MenuItem>
                                            </MenuList>
                                        </Menu>
                                        :
                                        <Button
                                            color="white"
                                            size={'sm'}
                                            className={`w-[40px] h-[40px] flex gap-[12px] items-center justify-center`}
                                            onClick={(event: any) => {
                                                event.stopPropagation()
                                                handleOpen(record)
                                            }}
                                        >
                                            <EyeIcon />
                                        </Button>
                                }
                            </Tooltip>
                        }
                        {
                            hasRoleAccess('acts.download_invoice', roles) &&
                            <DownloadBtn
                                icon={<FileIcon />}
                                tooltipText={t('acts_page.download_invoice_act')}
                                record={record}
                                handleDownloadFile={handleDownloadInvoice}
                            />
                        }
                        {
                            hasRoleAccess('acts.download', roles) &&
                            <>
                                {
                                    without_facsimile ?
                                        <Menu placement="bottom-end">
                                            <MenuHandler>
                                                <Button
                                                    color="white"
                                                    size={'sm'}
                                                    className={`w-[40px] h-[40px] flex gap-[12px] items-center justify-center`}
                                                >
                                                    <DownloadIcon />
                                                </Button>
                                            </MenuHandler>
                                            <MenuList >
                                                <MenuItem
                                                    onClick={(event: any) => {
                                                        event.stopPropagation()
                                                        handleDownloadAct(record)
                                                    }}
                                                    className={`flex items-center gap-[6px] py-[10px] px-[16px] text-gray-700`}
                                                >
                                                    {t('acts_page.download_act')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={(event: any) => {
                                                        event.stopPropagation()
                                                        handleDownloadAct({ ...record, without_facsimile: true })
                                                    }}
                                                    className={`flex items-center gap-[6px] py-[10px] px-[16px] text-gray-700`}
                                                >
                                                    {t('acts_page.download_act')} {t('without_facsimile')}
                                                </MenuItem>
                                            </MenuList>
                                        </Menu>
                                        :
                                        <DownloadBtn
                                            icon={<DownloadIcon />}
                                            tooltipText={t('acts_page.download_act')}
                                            record={record}
                                            handleDownloadFile={handleDownloadAct}
                                        />
                                }
                            </>
                        }
                        {
                            hasRoleAccess('acts.detailing', roles) ?
                                <>
                                    {
                                        service_id === 2 ?
                                            (record.balance_id === 5 && record.act_type === 7) ?
                                                <DownloadBtn
                                                    icon={<ExcelIcon className='w-[20px]' />}
                                                    tooltipText={t('acts_page.download_detail')}
                                                    record={record}
                                                    handleDownloadFile={handleDownloadDetail}
                                                />
                                                :
                                                ''
                                            :
                                            <DownloadBtn
                                                disabled={record.act_type === 3}
                                                icon={<ExcelIcon className='w-[20px]' />}
                                                tooltipText={t('acts_page.download_detail')}
                                                record={record}
                                                handleDownloadFile={handleDownloadDetail}
                                            />
                                    }
                                </>
                                :
                                <></>
                        }
                    </div>
                </div>
            )
        },
    ];

    const headCells = headCellsData.filter(i => !i.hidden)
    const handleDownloadDetail = (record: ActRowType, callback?: () => void) => {

        const servicePath = service_id === 2 ? '/api/acts/export-detailing-gas' : service_id === 1 ? '/api/acts/export-detailing' : false
        if (!servicePath) {
            errorToast({
                title: '',
                text: t('error_on_download')
            })
            if (callback) callback()
            return
        }
        let form = {
            contract_id: Number(param_contract_id),
            id: record.id
        }

        let filename = `${record.detailing_name}`

        axios.post(`${baseApi}${servicePath}`, form, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    errorToast({
                        title: t('acts_page.acts_title'),
                        text: t('error_on_download')
                    })
                }
                else fileDownload(response.data, filename)
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('acts_page.acts_title'),
                    text: t('error_on_download')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }
    const handleDownloadAct = (record: ActRowType, callback?: () => void) => {
        axios.post(`${baseApi}/api/acts/export-file`, {
            contract_id: Number(param_contract_id),
            ...record
        }, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    errorToast({
                        title: t('acts_page.acts_title'),
                        text: t('error_on_download')
                    })
                }
                else fileDownload(response.data, `${record.filename}.pdf`)
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('acts_page.acts_title'),
                    text: t('error_on_download')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }
    const handleDownloadInvoice = (record: ActRowType, callback?: () => void) => {
        axios.post(`${baseApi}/api/acts/export-invoice`, {
            contract_id: Number(param_contract_id),
            ...record
        }, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    errorToast({
                        title: t('acts_page.acts_title'),
                        text: t('error_on_download')
                    })
                }
                else fileDownload(response.data, `${record.invoiceFilename}.pdf`)
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('acts_page.acts_title'),
                    text: t('error_on_download')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }

    const handleDownloadSelected = (arr: number[]) => {
        axios.post(`${baseApi}/api/acts/export-files-zip`, {
            contract_id: Number(Number(param_contract_id)),
            arr: arr
        }, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    errorToast({
                        title: t('acts_page.acts_title'),
                        text: t('error_on_download')
                    })
                }
                else {
                    setSelected([])
                    fileDownload(response.data, `Files.zip`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('acts_page.acts_title'),
                    text: t('error_on_download')
                })
            })
    }

    const handleRowDoubleClick = (e: any, row: ActRowType) => {
        if (e?.detail === 2) {
            handleOpen(row)
        }
    }

    return (
        <>
            <ModalViewPdf
                formSend={formForViewPdf}
                open={open}
                handleClose={handleClose}
            />
            <TableToolbar
                isOpen={selected?.length > 0}
            >
                <Typography
                    color="inherit"
                // component="div" 
                >
                    {t('selected')}
                    <span className='font-bold'> {selected.length}  {t(`acts_page.doc_active_count_${numWord(selected.length)}`)}</span>
                </Typography>
                <Menu placement="top" >
                    <MenuHandler>
                        <Button color='white' className='w-[300px] px-[16px] rounded flex items-center justify-between'>
                            {t('action')}
                            <SelectIcon />
                        </Button>
                    </MenuHandler>
                    <MenuList className='w-[300px]'>
                        <MenuItem
                            className='p-[16px]'
                            onClick={() => {
                                handleDownloadSelected(selected)
                            }}
                        >
                            {t('acts_page.download_selected_documents')}
                        </MenuItem>
                    </MenuList>
                </Menu>
            </TableToolbar>

            <ActsCards
                roles={roles}
                service_id={service_id}
                visibleRows={visibleRows}
                isLoadingTable={isLoadingTable}
                handleDownloadInvoice={handleDownloadInvoice}
                handleDownloadAct={handleDownloadAct}
                handleDownloadDetail={handleDownloadDetail}
            />


            <TableContainer className='hidden tab:block'>
                <Table
                    sx={{
                        minWidth: 750,
                        borderCollapse: 'separate',
                        borderSpacing: '0 16px',
                    }}
                    size={'medium'}
                >
                    <TableHeadComponent />
                    <TableBody>
                        {
                            isIterableArray(visibleRows) ?
                                visibleRows.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    return (
                                        <TableRow
                                            key={row.id}
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            selected={isItemSelected}
                                            className={`  
                                                table-row-border
                                                service_id_${service_id}
                                                ${hoverRowService}
                                            `}
                                            onClick={(e: any) => handleRowDoubleClick(e, row)}
                                        >
                                            <TableCell
                                                padding="checkbox"
                                                sx={{
                                                    border: 'none', lineHeight: '120%',
                                                    borderTopLeftRadius: 16,
                                                    borderBottomLeftRadius: 16,

                                                }}
                                                onClick={(event: any) => {
                                                    event.stopPropagation()
                                                    handleClickCheckbox(event, row.id)
                                                }}
                                            >
                                                <div className='flex items-center min-h-[64px]'>
                                                    <Checkbox
                                                        disableRipple={true}
                                                        color="default"
                                                        className='svg-checkbox-dark hover:!bg-white'
                                                        checked={isItemSelected}
                                                    />
                                                </div>
                                            </TableCell>
                                            <TableRowsRender cells={headCells} row={row} />
                                        </TableRow>
                                    );
                                })
                                :
                                <TableEmptyRows isLoadingTable={isLoadingTable} />
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default ActTableDumb
